import { Outlet } from "react-router-dom";
import { useUserStore } from "entities/user";
import { Header } from "widgets";
import { Footer } from "widgets";
import { LkSidebar } from "./lk-sidebar/LkSidebar";
import styles from "./LkLayout.module.scss";

export const LkLayout = () => {
  const { user, role } = useUserStore();

  return (
    <div className={styles.pageContainer}>
      <div className={styles.pageWrapper}>
        <Header />
        <div className={styles.pageWrapper__mainContent}>
          <LkSidebar role={role} />
          <main className={styles.pageWrapper__main}>
            <Outlet />
          </main>
        </div>
      </div>
      <Footer />
    </div>
  );
};
